<template>
  <div class="user-form-shell">
    <div class="form-grid">
      <div class="field">
        <label class="label user-form-label" for="user-name">Nombre</label>
        <div class="control">
          <input id="user-name" v-model="localUser.name" class="input user-form-input" type="text" placeholder="Nombre completo" />
        </div>
      </div>

      <div class="field">
        <label class="label user-form-label" for="user-email">Email</label>
        <div class="control">
          <input id="user-email" v-model="localUser.email" class="input user-form-input" type="email" placeholder="correo@dominio.cl" />
        </div>
      </div>
    </div>

    <div class="field" v-if="showPassword">
      <label class="label user-form-label" for="user-password">Contrasena temporal</label>
      <div class="control">
        <input id="user-password" v-model="localUser.password" class="input user-form-input" type="password" placeholder="Contrasena inicial" />
      </div>
    </div>

    <div class="profile-panel">
      <div class="profile-panel-head">
        <div>
          <p class="profile-kicker">Perfiles</p>
          <p class="profile-copy">Asigna uno o varios perfiles para definir el alcance del usuario.</p>
        </div>
        <label class="status-toggle">
          <input v-model="localUser.enabled" type="checkbox">
          <span>{{ localUser.enabled ? 'Activo' : 'Inactivo' }}</span>
        </label>
      </div>

      <div class="profile-options">
        <label class="profile-option" v-for="profile in profiles" :key="profile.id">
          <input v-model="localUser.profile_ids" type="checkbox" :value="profile.id">
          <span class="profile-option-copy">{{ profile.description }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserForm',
  props: {
    userData: {
      type: Object,
      required: true
    },
    profiles: {
      type: Array,
      default: () => []
    },
    showPassword: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    localUser: {
      id: null,
      name: '',
      email: '',
      password: '',
      enabled: true,
      profile_ids: []
    }
  }),
  watch: {
    userData: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.localUser = {
          id: newValue.id || null,
          name: newValue.name || '',
          email: newValue.email || '',
          password: '',
          enabled: newValue.enabled !== false,
          profile_ids: (newValue.profile_ids || []).map(profileId => Number(profileId))
        }
      }
    }
  },
  methods: {
    submit() {
      this.$emit('save', {
        ...this.localUser,
        profile_ids: this.localUser.profile_ids.map(profileId => Number(profileId))
      })
    }
  }
}
</script>

<style scoped>
.user-form-shell {
  color: #1f2937;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.user-form-label {
  margin-bottom: 0.45rem;
  color: #4b5563;
  font-size: 0.84rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.user-form-input {
  height: 3.15rem;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 18px;
  box-shadow: none;
  background: rgba(255, 255, 255, 0.96);
}

.user-form-input:focus {
  border-color: rgba(31, 41, 55, 0.24);
  box-shadow: 0 0 0 4px rgba(31, 41, 55, 0.06);
}

.profile-panel {
  margin-top: 1.5rem;
  padding: 1.1rem;
  border: 1px solid rgba(15, 23, 42, 0.07);
  border-radius: 22px;
  background: linear-gradient(180deg, rgba(247, 247, 246, 0.92), rgba(255, 255, 255, 0.98));
}

.profile-panel-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.profile-kicker {
  margin: 0;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #6b7280;
}

.profile-copy {
  margin: 0.35rem 0 0;
  color: #6b7280;
}

.status-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.55rem 0.8rem;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 999px;
  background: #fff;
  color: #374151;
  font-weight: 600;
}

.profile-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.75rem;
}

.profile-option {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  min-height: 3rem;
  padding: 0.8rem 0.9rem;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.9);
}

.profile-option-copy {
  font-weight: 600;
  color: #374151;
}

@media screen and (max-width: 720px) {
  .form-grid {
    grid-template-columns: 1fr;
  }

  .profile-panel-head {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
